export enum ResponseStatusEnum {
  badRequest = 400,
  created = 201,
  conflict = 409,
  forbidden = 403,
  internalServerError = 500,
  noContent = 204,
  notFound = 404,
  ok = 200,
  redirect = 302,
  unauthorized = 401,
  unprocessableEntity = 422,
  tooManyRequests = 429,
  serviceUnavailable = 503,
  gatewayTimeout = 504,
  notImplemented = 501,
}
